import { Component, forwardRef, inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AutopayPaperlessPaymentComponent } from '../autopay-paperless-payment/autopay-paperless-payment.component';

@Component({
    selector: 'app-alt-autopay-paperless-payment',
    templateUrl: './alt-autopay-paperless-payment.component.html',
    styleUrl: './alt-autopay-paperless-payment.component.scss',
    providers: [
        {
            provide: AutopayPaperlessPaymentComponent,
            useExisting: forwardRef(() => AltAutopayPaperlessPaymentComponent)
        }
    ],
    standalone: false
})
export class AltAutopayPaperlessPaymentComponent extends AutopayPaperlessPaymentComponent implements OnInit {

  #fb: FormBuilder = inject(FormBuilder)

  override ngOnInit(): void {
    this.autopayPaperlessPaymentForm = this.#fb.group({
      autopayEnrollment: [this.autopaySelection],
      autopayEnrollmentTerms: [{ value: true, disabled: !this.autopaySelection }, Validators.requiredTrue],
      paperlessEnrollmentTerms: [{ value: false, disabled: !this.autopaySelection }, Validators.requiredTrue],
      payWithAch: [false],
      samePaymentMethod: [false]
    })

  }

  override autopayEnrollmentChange(event: any) {
    const autopayTerms = this.autopayPaperlessPaymentForm.get('autopayEnrollmentTerms')
    const paperlessTerms = this.autopayPaperlessPaymentForm.get('paperlessEnrollmentTerms')
    if (!event) {
      autopayTerms.disable()
      paperlessTerms.disable()
      autopayTerms.setValue(false)
      paperlessTerms.setValue(false)
    } else {
      autopayTerms.enable()
      paperlessTerms.enable()
    }
    this.autopayPaperlessPaymentForm.updateValueAndValidity()
  }
}
